module.exports = __webpack_public_path__ + "img/piling.c6901d25.jpg";